import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { authGuard } from "@/common/auth-guard";
import HomeView from "../views/HomeView.vue";
import System from "../components/system/Index.vue";
import Member from "../components/system/Member.vue"; // 账号管理
import Role from "../components/system/Role.vue"; // 角色管理
import Menu from "../components/system/Menu.vue"; // 菜单配置


/**日志 */
import OperateLogs from "../components/system/OperateLogs.vue"; // 操作日志
import LoginLogs from "../components/system/LoginLogs.vue"; // 登录日志
import DataChangesLogs from "../components/system/DataChangesLogs.vue"; // 数据变更日志

/**设备诊断 新*/
import Overview from "../components/diagnosis/overview.vue"; // 设备健康总览
import SensorN from "../components/diagnosis/sensor.vue"; // 设备健康总览


/**报警管理 */
import SmartAlarm from "../components/system/SmartAlarm.vue"; // 状态监测报警
import DiagnosisWaring from "../components/system/DiagnosisWaring.vue"; // 状态监测报警
import RuleSetting from "../components/system/RuleSetting.vue"; // 基础设置


/**状态监测 */
import SensorMonitoring from "../components/system/SensorMonitoring.vue"; // 传感器监测
import SoftwareMonitoring from "../components/system/SoftwareMonitoring.vue"; // 软件监测

/**知识库 */
import Metric from "../components/knowledge/metric.vue"


// 大屏
import cliqueDashboard from "../components/dashboard/clique.vue"  //集团大屏
import factoryDashboard from "../components/dashboard/factory.vue"  //厂级大屏
import machineDashboard from "../components/dashboard/machine.vue"  //设备大屏

// 设备管理
import Equipment from "../components/equipment/equipment.vue"

// 报警管理
import WarningList from "../components/warning-manage/warning-list.vue"

// 报告
import ReportList from "../components/report4/list.vue"
import ReportTemplate from "../components/report4/template.vue"
import MWReportInfo from "../components/report4/MWReportInfo.vue"

// 知识库
import KnowledgeFault from "../components/knowledge/fault.vue"
import KnowledgeModel from "../components/knowledge/model.vue"
import KnowledgeTranslation from "../components/knowledge/translations.vue"

import factoryModel from "../components/system/factory.vue"

// 开关机
import onModel from "../components/system/On.vue"

import { codeGuard } from "@/common/code-guard";

// 采集单元监测
import DigitizerMonitor from '@/components/system/digitizerMonitor.vue';
// 硬件监测报警
import HardwareWarning from '@/components/warning-manage/hardware-warning.vue';


import { menuGuard } from "@/common/menu-guard";

let diagnosisGuards: any[] = [() => {return true;}];
if (process.env.NODE_ENV === 'production') {
    diagnosisGuards = [codeGuard];
}

const routes: RouteRecordRaw[] = [
    {
        path: "/",
        name: "home",
        beforeEnter: authGuard,
        component: HomeView,
        children: [
            // { path: "dashboard", component: Dashboard },
            {
                path: "dashboard",
                redirect: "/dashboard/clique",
                children: [
                    { path: "clique", component: cliqueDashboard, beforeEnter: menuGuard },
                    { path: "factory", component: factoryDashboard, beforeEnter: menuGuard },
                    { path: "machine", component: machineDashboard, beforeEnter: menuGuard },
                ]
            },

            {
                path: "diagnosisN",
                redirect: "/diagnosisN/overview",
                children: [
                    { path: "overview", component: Overview, beforeEnter: menuGuard },
                    { path: "sensor", component: SensorN, beforeEnter: menuGuard }
                ],
            },

            {
                path: "equipment",
                redirect: "/equipment/list",
                children: [
                    { path: "list", component: Equipment, beforeEnter: menuGuard },
                ],
            },

            {
                path: "warning-manage",
                redirect: "/warning-manage/warning-list",
                children: [
                    { path: "warning-list", component: WarningList, beforeEnter: menuGuard },
                    // 报警管理中的智能诊断配置,需要隐藏专家看护配置
                    {
                        path: "diagnosisWaring",
                        component: DiagnosisWaring,
                        props: { hideExpertCareOptions: true },
                        beforeEnter: menuGuard
                    },
                    // 报警管理中的指标报警配置,需要隐藏专家看护配置
                    {
                        path: "smartAlarm",
                        component: SmartAlarm,
                        props: { hideExpertCareOptions: true },
                        beforeEnter: menuGuard
                    },
                    { path: "hardwareWarning", component: HardwareWarning, beforeEnter: menuGuard },

                ],
            },

            {
                path: "report",
                redirect: "/report/list",
                children: [
                    { path: "list", component: ReportList, beforeEnter: menuGuard },
                    { path: "mwDetail/:id", component: MWReportInfo },
                    { path: "template", component: ReportTemplate, beforeEnter: menuGuard },
                ],
            },

            {
                path: "knowledge",
                redirect: "/knowledge/fault",
                children: [
                    { path: "fault", component: KnowledgeFault, beforeEnter: menuGuard },
                    { path: "model", component: KnowledgeModel, beforeEnter: menuGuard },
                    { path: "translation", component: KnowledgeTranslation, beforeEnter: menuGuard },
                    
                ],
            },
            {
                path: "system",
                redirect: "/system/role",
                component: System,
                children: [
                    { path: "member", component: Member, beforeEnter: menuGuard },
                    { path: "role", component: Role, beforeEnter: menuGuard },
                    { path: "menu", component: Menu, beforeEnter: menuGuard },
                    { path: "factory", component: factoryModel, beforeEnter: menuGuard },
                    { path: "diagnosisWaring", component: DiagnosisWaring, beforeEnter: diagnosisGuards },
                    { path: "smartAlarm", component: SmartAlarm, beforeEnter: diagnosisGuards },
                    { path: "ruleSetting", component: RuleSetting },
                    { path: "on", component: onModel, beforeEnter: diagnosisGuards },
                    { path: "operateLogs", component: OperateLogs, beforeEnter: menuGuard },
                    { path: "loginLogs", component: LoginLogs, beforeEnter: menuGuard },
                    { path: "dataChangesLogs", component: DataChangesLogs, beforeEnter: menuGuard },
                    { path: "sensorMonitoring", component: SensorMonitoring, beforeEnter: menuGuard },
                    { path: "softwareMonitoring", component: SoftwareMonitoring, beforeEnter: menuGuard },
                    { path: "digitizerMonitoring", component: DigitizerMonitor, beforeEnter: menuGuard },

                ],
            },

            { path: "", redirect: "dashboard" },
            { path: "metric", component: Metric },

        ],
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/LoginView.vue"),
    },
    {
        path: "/code-valid",
        name: "code-valid",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import("../views/CodeValidView.vue"),
    },
    {
        path: "/week-report/:id",
        name: "week-report",
        component: () => import("../components/output/week-report.vue"),
    },
    {
        path: "/week-report-mobile/:id",
        name: "week-report-mobile",
        component: () => import("../components/output/week-report-mobile.vue"),
    },
    { path: "/forbidden-403", component: () => import("../views/forbidden-403.vue") }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
